class VideoBackground {
    /**
     * 
     * @param {HTMLDivElement} elem 
     */
    constructor(elem) {
        this._elem = elem;

        this._letterbox = new Image();
        this._letterbox.className = 'background-letterbox';

        this._elem.appendChild(this._letterbox);

        this._video = null;
        this._fitMode = 'cover';

        this._viewportWidth = 0;
        this._viewportHeight = 0;

        this._updateFitMode();
    }

    /**
     * 
     * @param {HTMLVideoElement} video 
     */
    setVideo(video) {
        const children = Array.from(this._elem.children).filter(child => child !== this._letterbox);
        for (let child of children) {
            this._elem.removeChild(child);
        }

        this._elem.appendChild(video);
        this._video = video;
        this._updateLetterbox();
    }

    /**
     * 
     * @param {string} fitMode
     */
    setFitMode(fitMode) {
        this._fitMode = fitMode;
        this._updateFitMode();
    }

    /**
     * 
     * @param {number} viewportWidth
     * @param {number} viewportHeight
     */
    setSize(viewportWidth, viewportHeight) {
        this._viewportWidth = viewportWidth;
        this._viewportHeight = viewportHeight;

        this._updateLetterbox();
    }

    _updateFitMode() {
        const addClass = this._fitMode;
        const removeClass = this._fitMode === 'cover' ? 'contain' : 'cover';

        this._elem.classList.add(addClass);
        this._elem.classList.remove(removeClass);

        this._updateLetterbox();
    }

    _updateLetterbox() {
        if (this._fitMode === 'cover' || !this._video) {
            this._letterbox.classList.add('hidden');
        } else {
            this._letterbox.classList.remove('hidden');
            const { _viewportWidth: viewportW, _viewportHeight: viewportH } = this;
            const { videoWidth, videoHeight } = this._video;
            this._letterbox.src = generateLetterboxSvg(viewportW, viewportH, videoWidth, videoHeight);
        }
    }
}

function generateLetterboxSvg(viewportW, viewportH, videoW, videoH) {
    const videoScale = Math.min(viewportW/videoW, viewportH/videoH);
    const finalVideoW = videoW*videoScale;
    const finalVideoH = videoH*videoScale;
    const finalVideoX0 = (viewportW-finalVideoW)*0.5;
    const finalVideoY0 = (viewportH-finalVideoH)*0.5;
    const finalVideoX1 = (viewportW+finalVideoW)*0.5;
    const finalVideoY1 = (viewportH+finalVideoH)*0.5;

    return [
        'data:image/svg+xml,',
        '<svg viewBox="0 0 '+viewportW+' '+viewportH+'" width="'+viewportW+'" height="'+viewportH+'" xmlns="http://www.w3.org/2000/svg">',
            '<path fill="black" fill-rule="evenodd" ',
                'd="',
                    'M 0 0 H '+viewportW+' V '+viewportH+' H 0 Z ',
                    'M '+finalVideoX0+' '+finalVideoY0+' H '+finalVideoX1+' V '+finalVideoY1+' H '+finalVideoX0+' Z',
                '"',
            ' />',
        '</svg>',
    ].join('');
}

export default VideoBackground;
export { VideoBackground };